var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support-up",on:{"click":_vm.click}},[_c('v-row',{staticClass:"support-up-row"},[_vm._v(" "+_vm._s(_vm.content)+" "),_c('v-spacer'),_c('v-icon',[_vm._v("mdi-arrow-up")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }